// Console entry point: applies the brand, then mounts the app with routing and auth.
// CloudFront returns index.html for unknown paths, so deep links work.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { applyBrand } from "./brand";
import { startClarity } from "./clarity";
import "./styles.css";

// Publish brand colours/fonts as CSS variables before the first paint
applyBrand();

// Microsoft Clarity analytics: production hosts only, and only after the
// visitor accepts analytics cookies (see clarity.ts)
startClarity();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
